import { PayloadAction } from "@reduxjs/toolkit";
import { StockPublicationSliceState } from "../../types";

const ensureDraft = (state: StockPublicationSliceState) => {
  if (!state.draftSettings) {
    return;
  }
  return state.draftSettings;
};

export const visibilityReducers = {
  setHiddenBrands: (
    state: StockPublicationSliceState,
    action: PayloadAction<string[]>,
  ) => {
    const draft = ensureDraft(state);
    if (!draft) {
      return;
    }
    draft.hiddenBrands = action.payload;
  },
  setHiddenModels: (
    state: StockPublicationSliceState,
    action: PayloadAction<string[]>,
  ) => {
    const draft = ensureDraft(state);
    if (!draft) {
      return;
    }
    draft.hiddenModels = action.payload;
  },
  setHiddenSizes: (
    state: StockPublicationSliceState,
    action: PayloadAction<string[]>,
  ) => {
    const draft = ensureDraft(state);
    if (!draft) {
      return;
    }
    draft.hiddenSizes = action.payload;
  },
  setHiddenDrillings: (
    state: StockPublicationSliceState,
    action: PayloadAction<string[]>,
  ) => {
    const draft = ensureDraft(state);
    if (!draft) {
      return;
    }
    draft.hiddenDrillings = action.payload;
  },
};
